import $ from 'jquery';

$(document).ready(function () {
    let $type = $('.js-firma-digitale')
    $type.find('[type=radio]').attr('disabled', false)
    let $input = $type.find('[name=type]')
    $type.on('change', onTypeChange)
    onTypeChange()
    function onTypeChange (e) {
        let selectedValue = $input.val();
        if (selectedValue === '1') {
            $('.js-digital').removeClass(`d-none`)
            $('.js-upload').addClass(`d-none`).find('input').attr('disabled', true)
        } else {
            $('.js-digital').addClass(`d-none`)
            $('.js-upload').removeClass(`d-none`).find('input').attr('disabled', false)
        }
    }
})
